module.exports = __webpack_public_path__ + "static/media/Teal_Check_Mark.a31ca777.gif";